import BaseStore from '@src/utils/store/base-store';
import toWebpImage from '@src/utils/to-webp-image';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const lang = getLanguageByPath();

class FifthPageStore extends BaseStore {
  mechaInfo = {
    id: 'welkin',
    bg: toWebpImage(require(`./images/${lang}/kv.jpg`)),
    btnDetail: toWebpImage(require(`./images/${lang}/btn-detail.png`))
  };

  use() {}
}
export default FifthPageStore;
